module.exports = {
    extends: [
        '/',
        'base',
        'bootstrap5',
        'events',
        'nextEventTimer',
    ],

    // TODO: wt: approve and / or cleanup
    config: {
        isCacheable: true
    }
}